const getters = {
  // sidebar: state => state.app.sidebar,
  // language: state => state.app.language,
  // visitedViews: state => state.tagsView.visitedViews,
  // cachedViews: state => state.tagsView.cachedViews,
  // token: state => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  // introduction: state => state.user.introduction,
  // status: state => state.user.status,
  // roles: state => state.user.roles,
  // setting: state => state.user.setting,
  // permission_routers: state => state.permission.routers,
  // addRouters: state => state.permission.addRouters,
  // roleList: state => state.permission.roleList,
  // errorLogs: state => state.errorLog.logs,
  // orderTag: state => state.order.tag
  isCollect: state => state.collect.isCollect,
  expectDate: state => state.expect.expectDate
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js